import {fetch, normalize} from "utils/dataAccess";
import persist from "./persister";

export default function update(shippingMethod, values) {
    values = persist(values)

    return new Promise((resolve, reject) => {
        fetch(shippingMethod['@id'], {
            method: "PATCH",
            body: JSON.stringify(values),
            headers: new Headers({'Content-Type': 'application/merge-patch+json'}),
        }).then(response => response.json()).then((retrieved) => {
            resolve(normalize(retrieved));
        }).catch(error => reject(error));
    });
}
